export default {
	HOVER: 'hover',
	CLICK: 'click',
};
